import React from "react";

import { QuestionIcon } from "@primer/octicons-react";
import InfoModal from "../components/InfoModal";
import withModal from "../util/withModal";

const InfoButton = withModal("span", InfoModal);

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <header className="p-5 border-b border-gray-300">
        <div className="container mx-auto flex justify-center items-center">
          <div className="flex items-center space-x-4">
            <h1 className="text-black text-3xl font-medium">
              Synergy Connections
            </h1>
            <InfoButton
              modalProps={{
                title: "About Synergy Connections",
                message:
                  "In the grid there are 16 cards. There are four groups of four cards, where each group contains the four cards with the highest synergy of a hidden card. Your goal is to group the cards into the correct grouppings. Synergy is determined from the Cube Cobra recommendation system, and cards are chosen by popularity to avoid too fringe selections.",
              }}
              className="hover:cursor-pointer transition-all duration-500"
              size={16}
            >
              <QuestionIcon size={16} />
            </InfoButton>
          </div>
        </div>
      </header>
      <main className="flex-grow bg-gray-200">
        <div className="container mx-auto p-5">{children}</div>
      </main>
    </div>
  );
};

export default MainLayout;
